// Shared role dimension for the "Explore by Role" section on the public landing
// page. Mirrors `audience.ts`: the type plus the per-role tab metadata live here
// so the role dimension is parameterized in one place, while the marketing copy
// for each panel lives in `content.ts` (`ROLE_PANELS`).
// Tab order, left to right. Also drives arrow-key navigation in the tablist.
export const ROLE_ORDER = [
    'explore-local-government',
    'explore-historic-association',
    'explore-homeowner',
];
// The tab shown when the section first renders.
export const DEFAULT_ROLE = 'explore-local-government';
export const ROLE_TAB_LABEL = {
    'explore-local-government': 'Local Government',
    'explore-historic-association': 'Historic Association',
    'explore-homeowner': 'Homeowner/Resident',
};
export const ROLE_TAB_ICON = {
    'explore-local-government': 'bi-bank',
    'explore-historic-association': 'bi-book',
    'explore-homeowner': 'bi-house',
};
